import { isValidEmailAddress, isValidPassword } from '../functions';


$(document).ready(function() {

	var registerLoading = false;
	$(document).on('click', '#submit-register-form-btn', function() {
		if (registerLoading) { return false; }
		console.log('click!!!!!');
		registerLoading = true;
		$('#register-form').submit();
    });

});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/register.js